// Página temporal para testear la conexión a Supabase
// Ruta: /supabase-test
import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

const SupabaseTest = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);
  const [realtimeMsg, setRealtimeMsg] = useState(null);

  useEffect(() => {
    const runTests = async () => {
      const tables = [
        'users', 'courses', 'commission_rules', 'attendance_records',
        'notifications', 'overtime_records', 'direct_chats', 'schedules',
        'sales_records', 'asesores', 'instructors', 'zoom_accounts',
        'workspace_projects', 'workspace_folders', 'workspace_lists',
        'workspace_items', 'workspace_sections', 'workspace_snippets',
        'workspace_ai_conversations', 'workspace_ai_memory',
      ];

      const res = {};
      for (const table of tables) {
        try {
          const { data, error } = await supabase.from(table).select('*');
          if (error) {
            res[table] = { ok: false, error: error.message };
          } else {
            res[table] = { ok: true, count: data.length, sample: data.slice(0, 2) };
          }
        } catch (e) {
          res[table] = { ok: false, error: e.message };
        }
      }
      setResults(res);
      setLoading(false);
    };

    runTests();

    // Test realtime
    const channel = supabase
      .channel('test-realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'users' }, (payload) => {
        setRealtimeMsg(`Evento: ${payload.eventType} en users a las ${new Date().toLocaleTimeString()}`);
      })
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  const totalDocs = Object.values(results).reduce((sum, r) => sum + (r.count || 0), 0);

  return (
    <div style={{ padding: 32, maxWidth: 900, margin: '0 auto', fontFamily: 'system-ui' }}>
      <h1 style={{ fontSize: 24, marginBottom: 8 }}>🧪 Test de Conexión Supabase</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>
        URL: {process.env.REACT_APP_SUPABASE_URL}
      </p>

      {loading ? (
        <p>Cargando tests...</p>
      ) : (
        <>
          <div style={{
            background: totalDocs > 0 ? '#dcfce7' : '#fef2f2',
            padding: 16, borderRadius: 8, marginBottom: 24
          }}>
            <strong>{totalDocs > 0 ? '✅' : '❌'} Total documentos accesibles: {totalDocs}</strong>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
                <th style={{ textAlign: 'left', padding: 8 }}>Tabla</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Estado</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Registros</th>
                <th style={{ textAlign: 'left', padding: 8 }}>Muestra</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(results).map(([table, info]) => (
                <tr key={table} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <td style={{ padding: 8, fontWeight: 600 }}>{table}</td>
                  <td style={{ padding: 8 }}>{info.ok ? '✅' : '❌'}</td>
                  <td style={{ padding: 8 }}>{info.count ?? info.error}</td>
                  <td style={{ padding: 8, fontSize: 12, color: '#666', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {info.sample?.[0] && (
                      info.sample[0].title || info.sample[0].display_name || info.sample[0].email || info.sample[0].name || JSON.stringify(info.sample[0]).substring(0, 80)
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {realtimeMsg && (
            <div style={{ marginTop: 24, padding: 16, background: '#eff6ff', borderRadius: 8 }}>
              <strong>📡 Realtime:</strong> {realtimeMsg}
            </div>
          )}

          <div style={{ marginTop: 32, padding: 16, background: '#f9fafb', borderRadius: 8 }}>
            <h3 style={{ marginBottom: 8 }}>📋 Siguiente paso</h3>
            <p>Si ves todos los datos correctos arriba, la conexión funciona.</p>
            <p>Para probar realtime: ve al dashboard de Supabase → tabla "users" → edita cualquier campo. Deberías ver un mensaje aquí.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default SupabaseTest;
